import React from "react";

export const TriggerScreenshotIcon: React.FC<
  React.SVGProps<SVGSVGElement>
> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M2.44223 9.55723C2.62702 9.74202 2.85059 9.83441 3.11296 9.83441H4.74973V8.8865H3.11296V7.24973H2.16504V8.8865C2.16504 9.14886 2.25743 9.37244 2.44223 9.55723Z"
      fill="#4C4CF6"
    />
    <path
      d="M7.24973 8.8865V9.83441H8.8865C9.14886 9.83441 9.37244 9.74202 9.55723 9.55723C9.74202 9.37244 9.83441 9.14886 9.83441 8.8865V7.24973H8.8865V8.8865H7.24973Z"
      fill="#4C4CF6"
    />
    <path
      d="M2.16504 3.11296V4.74973H3.11296V3.11296H4.74973V2.16504H3.11296C2.85059 2.16504 2.62702 2.25743 2.44223 2.44223C2.25743 2.62702 2.16504 2.85059 2.16504 3.11296Z"
      fill="#4C4CF6"
    />
    <path
      d="M8.8865 3.11296V4.74973H9.83441V3.11296C9.83441 2.85059 9.74202 2.62702 9.55723 2.44223C9.37244 2.25743 9.14886 2.16504 8.8865 2.16504H7.24973V3.11296H8.8865Z"
      fill="#4C4CF6"
    />
    <rect x="4.5" y="4.5" width="3" height="3" rx="1" fill="#4C4CF6" />
  </svg>
);
